// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__FiNI4","titleIcon":"styles_titleIcon__EPJ16","tipAccordion":"styles_tipAccordion__cKsLg"};